/* eslint-disable @reatom/unit-naming-rule */
import { atom } from '@reatom/framework'

import { Array, AsyncStateN, pipe, Result } from '@blade/std-lib'
import { reatomResource } from '@root/shared/lib'

import { Referee } from '../model'

import { fetchUserReferralsRequestAction } from './referral-requests'

import type { Error } from '@root/shared'

export const referralsStateAtom = atom(
  AsyncStateN.notInitiated<Error.UnknownError, Array<Referee.Referee>>(),
  'referralsStateAtom',
)

export const userReferralsStateAtom = reatomResource(
  async (ctx) => {
    const result = await ctx.schedule(() =>
      fetchUserReferralsRequestAction(ctx),
    )

    const mappedResult = pipe(
      result,
      Result.map((it) => pipe(it, Array.sort(Referee.cmpByProfitDesc))),
    )

    return mappedResult
  },
  {
    reconnectStrategy: 'refresh',
  },
)
